export default "__VITE_ASSET__CXB7DDRy__"